/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {currencyNumberFormat} from "utils/utility";
import React from "react";
import {PackageItem} from "types/entities/PackageItem";
import {useTranslation} from "react-i18next";
import clsx from "clsx";

interface PackageProps {
    packageItem: PackageItem;
    className?: string;
    isSeller?: boolean;
}

export const PackageUpsellItemPrice = (props: PackageProps) => {
    const {t} = useTranslation();
    return (
        <div className={clsx("PackageUpsellItemPrice flex flex-col", props.className)}>
            <b className={clsx("text-lg", props.isSeller && "leading-none")}>{currencyNumberFormat(props.packageItem.price)}</b>
            {props.packageItem.discount !== 0 && (
                <div className={"flex flex-row gap-x-3"}>
                    <div className={"relative"}>
                        <small className={"font-medium text-base text-gray-700"}>{currencyNumberFormat(props.packageItem.original_price)}</small>
                        <aside className={"absolute w-full transform-gpu -rotate-3 h-px left-0 bottom-1/2 bg-red-400"} />
                    </div>
                    <div className={"rounded-full text-sm px-1 py-px bg-red-400 text-white"}>- {props.packageItem.discount}%</div>
                </div>
            )}

            <h4
                className={clsx(
                    "font-light text-gray-800 text-xs sm:text-sm",
                    (props.isSeller && props.packageItem.discount !== 0) && "!leading-none",
                    (props.isSeller && props.packageItem.discount === 0) && "!leading-none mt-1",
                )}
            >
                {props.packageItem.extra.whole_group ? t("Price per person") : t("Price per item")}
            </h4>
        </div>
    );
};
